// Import Actions
import { persistData, getPersistedData } from '../../util/persistor.js';

import { SET_ITEM, SET_ITEM_QUANTITY, REMOVE_ITEM, REMOVE_ITEMS, SET_INVOICE_ADDRESS, SET_SHIPPING_ADDRESS, SET_SHIPPING_METHOD, SET_CART_OPTION, ADD_CART_NOTE, CLEAR_CART } from './CartActions.js';
import { APPLY_VOUCHER, REMOVE_VOUCHER, REMOVE_VOUCHERS } from '../Voucher/VoucherActions.js';
import { INIT_PERSISTED_DATA } from '../App/AppActions.js';

// Initial State
export const initialState = {
    items: [],
    shipping: {
        // address: {
        //     countryCode: '', // cca2 code like 'FR'
        //     postalCode: '', // string: '66000'
        // },
        // carrier: ''
    },
    invoice: {
        // address: {},
    },
    vouchers: [],
    isVoucherPrioritary: false,
    options: {},
    note: '',
};

const CartReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_ITEM: {
            // Panier mono-produit : un seul article à la fois.
            // Ajouter un produit remplace le contenu du panier ; ré-ajouter
            // le même produit (même productId + conversationId) le met à jour.
            const existingItem = state.items.find(item => item.productId === action.item.productId && (item.conversationId || null) === (action.item.conversationId || null));
            const newState = {
                ...state,
                items: existingItem ? [{ ...existingItem, ...action.item }] : [action.item],
            };
            persistData('cart', newState);
            return newState;
        }

		case SET_ITEM_QUANTITY: {
			const newState = {
				...state,
				items: state.items.map(item => {
					if(item.id === action.itemId) {
						return {
							...item,
							quantity: action.quantity,
						};
					}
					return item;
				}),
			};
            persistData('cart', newState);
            return newState;
		}

        case REMOVE_ITEM: {
            const newState = {
                ...state,
                items: state.items.filter(item => item.id !== action.itemId),
            };
            persistData('cart', newState);
            return newState;
        }

        case REMOVE_ITEMS: {
            const newState = {
                ...state,
                items: [],
            };
            persistData('cart', newState);
            return newState;
        }

        case CLEAR_CART: {
            const newState = {
                ...state,
                items: [],
                vouchers: [],
                isVoucherPrioritary: false,
                shipping: state.shipping,
                options: {},
            };
            persistData('cart', newState);
            return newState;
        }

        case SET_INVOICE_ADDRESS: {
            const newState = {
                ...state,
                invoice: {
                    ...state.invoice,
                    address: action.address,
                },
            };
            persistData('cart', newState);
            return newState;
        }

        case SET_SHIPPING_ADDRESS: {
            const newState = {
                ...state,
                shipping: {
                    ...state.shipping,
                    address: action.address,
                },
            };
            persistData('cart', newState);
            return newState;
        }

        case SET_SHIPPING_METHOD: {
            const newState = {
                ...state,
                shipping: {
                    ...state.shipping,
                    method: action.method,
                },
            };
            persistData('cart', newState);
            return newState;
        }

        case APPLY_VOUCHER: {
            let vouchers = [...state.vouchers];
            if(!action.voucher.isCumulative) {
                vouchers = [];
            }
            const newState = {
                ...state,
                vouchers: [...vouchers.filter(voucher => voucher._id !== action.voucher._id), action.voucher],
                isVoucherPrioritary: action.isPrioritary,
            };
            persistData('cart', newState);
            return newState;
        }

        case REMOVE_VOUCHER: {
            const newState = {
                ...state,
                vouchers: state.vouchers.filter(voucher => voucher.code !== action.code),
                isVoucherPrioritary: false,
            };
            persistData('cart', newState);
            return newState;
        }

        case REMOVE_VOUCHERS: {
            const newState = {
                ...state,
                vouchers: [],
                isVoucherPrioritary: false,
            };
            persistData('cart', newState);
            return newState;
        }

        case SET_CART_OPTION: {
            const newState = {
                ...state,
                options: {
                    ...(state.options || {}),
                    [action.key]: action.value,
                },

            };
            persistData('cart', newState);
            return newState;
        }

        case ADD_CART_NOTE: {
            const newState = {
                ...state,
                note: action.note,

            };
            persistData('cart', newState);
            return newState;
        }

        case INIT_PERSISTED_DATA:
            return getPersistedData('cart', state);

        default:
            return state;
    }
};

export default CartReducer;
